import { render, staticRenderFns } from "./MsgListDialog.vue?vue&type=template&id=9575a336"
import script from "./MsgListDialog.vue?vue&type=script&lang=js"
export * from "./MsgListDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports